import { createGlobalStyle } from 'styled-components/macro';

export default createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.fontFamily.regular};
  }

  ::selection {
    background-color: rgb(94, 197, 237, 0.3);
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1 {
    ${({ theme }) =>
      theme.fontFamily.regular.includes('Poppins')
        ? `
          font-family: 'Baloo-Paaji' !important;
          font-weight: 600 !important;
          font-size: 2rem !important;
          
          @media (max-width: ${theme.breakpoints.md}) {
            font-size: 1.8rem !important;
          }
        `
        : ''}
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  .ant-picker-active-bar {
    background: ${({ theme }) => theme.colors.primary} !important;
} 
  .ant-picker-outlined {
     :focus-within {
      border-color: ${({ theme }) => theme.colors.primary} !important;
     }
  }

.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner {
background-color: ${({ theme }) => theme.colors.primary} !important;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
background-color: ${({ theme }) => theme.colors.primary} !important;
}

.ant-picker-cell-in-view.ant-picker-cell-today
.ant-picker-cell-inner::before {
border-color: ${({ theme }) => theme.colors.primary} !important;
}
`;
